import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c708440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-auto" }
const _hoisted_2 = { class: "tw-flex tw-items-center tw-gap-2.5 tw-h-[21px]" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[16px] tw-font-[600] tw-not-italic tw-leading-[21px]" }
const _hoisted_4 = {
  key: 0,
  class: "tw-ml-1 tw-text-[#F7553C]"
}
const _hoisted_5 = { class: "tw-text-[#878787] tw-text-[13px] tw-font-[400] tw-leading-normal tw-min-h-[20px]" }
const _hoisted_6 = { class: "tw-flex tw-justify-end tw-items-center tw-pb-10" }

import { getComponentUiText } from "@/utils/utilities";
import { computed, nextTick, onUnmounted, ref, watch } from "vue";
import ActionDetail from "./editActionModalElement/actionDetail.vue";
import Questions from "./editActionModalElement/questions.vue";
import StepToSolve from "./editActionModalElement/stepToSolve.vue";
import store from "@/store";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { addStep } from "@/services/recommend";
import {
  showErrorAPI,
  showSuccessToast,
  showToastMessage,
} from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
import { ToastVariant } from "@/interfaces/common/IToastMessage";
import ProgressAnimation from "../../assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'createActionNewTab',
  props: {
  data: {
    type: Object,
    required: false,
    default: () => ({}),
  },
  show: {
    type: Boolean,
    required: true,
  },
},
  emits: ["update:show", "update:data"],
  setup(__props, { emit }) {

const props = __props;




const ActionDetailsRef: any = ref(null);
const isDirty = ref(false);
const actionData = ref<any>({
  ...props.data,
  checklistGroupName:
    props.data?.checklistGroupName ||
    props.data?.checklistGroupTemplateName ||
    "",
  checklistGroupDescription: props.data?.checklistGroupDescription || "",
});

const showRef = ref(props.show);
const isLoadingAPI = ref(false);

watch(
  () => props.show,
  (value) => {
    showRef.value = value;
  },
);

watch(
  () => props.data,
  () => {
    actionData.value.checklistGroupName =
      props.data?.checklistGroupName ||
      props.data?.checklistGroupTemplateName ||
      "";
    actionData.value.checklistGroupDescription =
      props.data?.checklistGroupDescription || "";
  },
);

const listAssessmentQuestionsSelected = computed(
  () => store.state.Recommend.selectedChecklistAssessmentQuestions,
);

const addSteps = async (payload) => {
  try {
    const promises: any = [];

    if (payload.listSteps.length > 0) {
      // Create promises for adding steps
      const addPromises = payload.listSteps.map((item) => {
        const stepData = {
          checklistGroupActionHtml: item.checklistGroupActionHtml,
          checklistGroupActionName: item.checklistGroupActionName,
          checklistGroupActionOrder: item.checklistGroupActionOrder,
        };
        return addStep(payload.checklistId, payload.checkListGroupId, stepData);
      });
      promises.push(...addPromises);
    } else {
      handleCloseModal();
    }
    const results = await Promise.all(promises);
    let error = 0;
    results.forEach((result) => {
      if (result.status === 200) {
        showSuccessToast(
          getComponentUiText("app-assess-recommend-step-message-1"),
        );
        handleCloseModal();
      } else if (result.status === "rejected") {
        error++;
      }
      if (error > 1) {
        showToastMessage(
          getComponentUiText("app-exception-handler-error-unknown-error"),
          ToastVariant.ERROR,
        );
      }
    });
  } catch (error) {
    showErrorAPI(error, Checklist.addStep);
  }
};

const handleCloseModal = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
};

onUnmounted(() => {
  store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", []);
  store.commit("Recommend/SET_LIST_STEP_REMOVED", null);
  store.commit("Recommend/SET_DATA_ACTION", {});
});

const arrayData = [
  {
    key: "ActionDetails",
    title: getComponentUiText(
      "app-assess-recommendations-edit-action-modal-action-detail-1",
    ),
    description: getComponentUiText(
      "app-assess-recommendations-edit-action-modal-action-detail-sub-title-1",
    ),
    component: ActionDetail,
    props: {
      placeholderTitleInput: getComponentUiText(
        "app-user-profile-form-label-title-1",
      ),
    },
  },
  {
    key: "Questions",
    title: getComponentUiText(
      "app-assess-recommendations-edit-action-modal-question-1",
    ),
    description: getComponentUiText(
      "app-assess-recommendations-edit-action-modal-action-question-sub-title-1",
    ),
    component: Questions,
    props: {
      isSuggestedAction: true,
      isCreateAction: true,
      assessmentQuestionsSelected: listAssessmentQuestionsSelected.value,
    },
    isRequired: true,
  },
  {
    key: "StepsToSolve",
    title: getComponentUiText(
      "app-assess-recommendations-action-table-label-tab-action-plan-1",
    ),
    description: getComponentUiText(
      "app-assess-recommendations-edit-action-modal-action-plan-sub-title-1",
    ),
    component: StepToSolve,
    props: {},
  },
];

const handleUpdateData = (data) => {
  isDirty.value = true;
  actionData.value = Object.assign(actionData.value, data);
};

const listSteps = computed(() => {
  return store.state.Recommend.listStepActionsPlan;
});

const checkAllValidations = async () => {
  const isValidListSteps = listSteps.value.every(
    (item) => item.isValid === true,
  );
  return {
    isValid: isValidListSteps,
    listSteps: listSteps.value.map((item) => {
      const { isValid, ...rest } = item;
      return rest;
    }),
    listSrepRemove: store.state.Recommend.listStepRemoved,
    checkListGroupId: actionData.value.checklistGroupId,
  };
};

const saveDataStepsToSolve = async () => {
  store.commit("Recommend/SET_IS_CREATING_ACTION", true);
  setTimeout(() => {
    store.commit("Recommend/SET_IS_CREATING_ACTION", false);
  }, 100);
  const isValidation = await ActionDetailsRef.value[0].saveChanges();
  await nextTick();
  const data = await checkAllValidations();
  if (data.isValid && !isValidation) {
    isLoadingAPI.value = true;
    store.commit("Recommend/SET_LIST_STEP_ACTIONS_PLAN", []);
    store.commit("Recommend/SET_LIST_STEP_REMOVED", null);
    const res = await store.dispatch("Recommend/createAction");
    eventEmitter.emit(EmitterEvents.RELOAD_RECOMMENDATION);
    eventEmitter.emit(EmitterEvents.RESET_SORT_TABLE);
    store.commit("Recommend/REMOVE_SELECTED_ASSESSMENT_QUESTIONS");
    if (res.checklistItemGroupId) {
      const dataSend = {
        listSteps: data.listSteps,
        checkListGroupId: res.checklistItemGroupId,
        checklistId: res.checklistId,
        checklistItemGroupOrder: res.checklistItemGroupOrder,
      };
      addSteps(dataSend);
    }
  }
  isLoadingAPI.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(arrayData, (item, index) => {
      return _createElementVNode("div", {
        key: item.key,
        class: _normalizeClass(`tw-px-[20px] tw-py-[40px] sm:tw-p-[40px] tw-flex tw-flex-col ${
          index !== 0
            ? 'tw-border-0 tw-border-t tw-border-solid tw-border-[#EFF0F1] tw-gap-[25px]'
            : 'tw-gap-[20px]'
        }`)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`tw-flex tw-flex-col tw-justify-between tw-w-full tw-min-h-[51px] tw-gap-2.5 ${
            index !== 0 ? '' : 'tw-mb-[5px]'
          }`)
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(item.title), 1),
              (item.isRequired)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(item.description), 1)
        ], 2),
        (item?.component)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({
              key: 0,
              ref_for: true,
              ref_key: "ActionDetailsRef",
              ref: ActionDetailsRef
            }, item?.props, {
              "in-modal-add": true,
              action: actionData.value,
              "onUpdate:data": handleUpdateData
            }), null, 16, ["action"]))
          : _createCommentVNode("", true)
      ], 2)
    }), 64)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_b_button, {
        style: {"height":"39px"},
        variant: "primary",
        class: _normalizeClass(`tw-shadow-none tw-relative tw-bg-[#387DFF] tw-px-[18px] tw-py-[0px] tw-text-[15px] tw-font-medium tw-rounded-[27px] tw-mr-10`),
        type: "submit",
        "data-cy": "create-action-new-tab-save-button",
        onClick: saveDataStepsToSolve
      }, {
        default: _withCtx(() => [
          (isLoadingAPI.value)
            ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                key: 0,
                "animation-data": _unref(ProgressAnimation),
                "auto-play": true,
                loop: true,
                class: _normalizeClass('tw-h-[39px] tw-w-full')
              }, null, 8, ["animation-data"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-modal-assessment-create-button-1",
            )), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})